/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type UndoCheckInInput = {
    bookingId: string;
};
export type UndoCheckInMutationVariables = {
    input: UndoCheckInInput;
};
export type UndoCheckInMutationResponse = {
    readonly UndoCheckInMutation: boolean;
};
export type UndoCheckInMutation = {
    readonly response: UndoCheckInMutationResponse;
    readonly variables: UndoCheckInMutationVariables;
};



/*
mutation UndoCheckInMutation(
  $input: UndoCheckInInput!
) {
  UndoCheckInMutation(input: $input)
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "kind": "ScalarField",
    "name": "UndoCheckInMutation",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UndoCheckInMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UndoCheckInMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f39761c193b5bd4d49a6925bea5df18a",
    "id": null,
    "metadata": {},
    "name": "UndoCheckInMutation",
    "operationKind": "mutation",
    "text": "mutation UndoCheckInMutation(\n  $input: UndoCheckInInput!\n) {\n  UndoCheckInMutation(input: $input)\n}\n"
  }
};
})();
(node as any).hash = 'f75231246f48f5b3d8447ff5f6d1ff34';
export default node;
